import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfl_J3_S } from "../../../modules/Beräkningsmoduler/BFL_J3_S";
import NumberEditor from "../../Global/Editors/NumberEditor";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card } from "react-bootstrap";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFL_J3_S = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfl_J3_S().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontroller = bm.funktionsKontroller;

  const systemText = global.beräkningsflikarText.beskr_BFL_J3_S;

  return (
    <div>
      <Card className="mb-3">
        {/* <Card.Header>BFL J3 S</Card.Header>
        <Card.Body>
          Driftoptimering för Ventilationsaggregat
          <ol>
            <li>Årlig energi ventilation självdrag (KWh)</li>
            <li>Beräkning returneras till Grunddata BIM cell H17 för beräkning energibalans</li>
            <li>Ingen funktion för driftoptimering eller funktionskontroll.</li>
          </ol>
        </Card.Body> */}
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFL_J3_S" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
      {/* <div className="row ml-0">
        <NumberEditor
          label="9. Beräknad energianvändning för ventilation per år -> BIM (Temp för test...)"
          formHook={formHook}
          fieldName="data.export.årligEnergiAnvändning"
          isDisabled={true}
        />
      </div> */}
    </div>
  );
};

export default BFL_J3_S;
